import { render, staticRenderFns } from "./FaqQuestionDetail.vue?vue&type=template&id=4cb7079d&scoped=true"
import script from "./FaqQuestionDetail.vue?vue&type=script&lang=js"
export * from "./FaqQuestionDetail.vue?vue&type=script&lang=js"
import style0 from "./FaqQuestionDetail.vue?vue&type=style&index=0&id=4cb7079d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb7079d",
  null
  
)

export default component.exports